import React from 'react';
import { FormikProps } from 'formik';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DomesticPartnerWizard } from '../wizard/domestic-partner-wizard';
import { DomesticPartnerFormAction } from '../model/domestic-partner-form-models';


interface Props {
    formProps: FormikProps<any>;  
    disabled: boolean;
    wizard: DomesticPartnerWizard;
}
export function DomesticPartnerActionFields(props: Props) {
    const {
        formProps,
        disabled,
        wizard,
       } = props;
    
    const currentDomesticPartnerAction = wizard?.getDomesticPartnerActionOptions(wizard?.getCurrentDomesticPartner());

    if ( currentDomesticPartnerAction?.length >= 0 && currentDomesticPartnerAction[0].value === DomesticPartnerFormAction.ESTABLISH) {
        const url = new URL(window.location.href);
		if (url.searchParams.has('action')) {
		  url.searchParams.delete('action');
		  window.history.replaceState(null, '', url.toString());
		}
    }

    return (
        <FormGroup>
            <FormField
                name='formAction'
                label={wizard?.getRelationShipSettings()?.domesticPartnerActionLabel}
                component="radioGroup"
                options={wizard?.getDomesticPartnerActionOptions(wizard?.getCurrentDomesticPartner())}
                touched={formProps.touched}
                errors={formProps.errors}
                row
                required
                disabled={disabled}
            />
        </FormGroup>
    );
}